export const STATUS_LABELS = {
  pending: 'قيد الانتظار',
  assigned: 'تم الإسناد',
  accepted: 'قبول الطلب',
  on_the_way_to_store: 'في الطريق للمتجر',
  arrived_at_store: 'وصل المتجر',
  picked_up_from_store: 'تم الاستلام من المتجر',
  on_the_way_to_customer: 'في الطريق للزبون',
  arrived_at_customer: 'وصل الزبون',
  delivered: 'تم التوصيل',
  not_delivered: 'لم يتم التوصيل',
  returned: 'مرتجع للتاجر',
  received_by_merchant: 'استلام التاجر',
  return_initiated: 'إعادة إلى المتجر',
  returning_to_store: 'عودة إلى المتجر',
  returned_at_store: 'تم الإرجاع للمتجر',
  delivery_failed: 'تعذر التوصيل',
  not_received: 'لم يتم الاستلام',
  cancelled: 'ملغي',
  postponed: 'مؤجلة',
  in_branch_transit: 'نقل بين الفروع',
  // Legacy
  picked_up: 'تم الاستلام',
  in_transit: 'في الطريق',
  arrived_at_branch: 'وصل الفرع',
  out_for_delivery: 'خرج للتوصيل',
};

/** Public customer tracking — never expose other orders on the truck. */
export const PUBLIC_IN_BRANCH_TRANSIT_LABEL = 'الطلب في النقل بين الفروع';

export const STATUS_COLORS = {
  pending: '#ff9800',
  assigned: '#2196f3',
  accepted: '#8B5CF6',
  on_the_way_to_store: '#3B82F6',
  arrived_at_store: '#F59E0B',
  picked_up_from_store: '#F97316',
  on_the_way_to_customer: '#9c27b0',
  arrived_at_customer: '#10B981',
  delivered: '#4caf50',
  not_delivered: '#ff9800',
  returned: '#607d8b',
  received_by_merchant: '#5d4037',
  return_initiated: '#795548',
  returning_to_store: '#ff6f00',
  returned_at_store: '#607d8b',
  delivery_failed: '#d32f2f',
  not_received: '#e91e63',
  cancelled: '#f44336',
  postponed: '#78909c',
  in_branch_transit: '#1565c0',
  // Legacy
  picked_up: '#3E2C6E',
  in_transit: '#9c27b0',
  arrived_at_branch: '#e91e63',
  out_for_delivery: '#ff6f00',
};

export const STATUS_FLOW = {
  pending: ['assigned', 'cancelled', 'in_branch_transit'],
  assigned: ['accepted', 'cancelled', 'delivery_failed'],
  accepted: ['on_the_way_to_store', 'picked_up', 'cancelled', 'delivery_failed'],
  on_the_way_to_store: ['arrived_at_store', 'delivery_failed', 'cancelled'],
  arrived_at_store: ['picked_up_from_store', 'delivery_failed', 'cancelled'],
  picked_up_from_store: ['on_the_way_to_customer', 'return_initiated', 'delivery_failed'],
  on_the_way_to_customer: ['arrived_at_customer', 'return_initiated', 'delivery_failed'],
  arrived_at_customer: ['delivered', 'not_delivered', 'delivery_failed', 'not_received', 'return_initiated'],
  not_delivered: ['on_the_way_to_customer', 'returning_to_store', 'delivery_failed', 'not_received'],
  returning_to_store: ['returned_at_store', 'returned', 'delivery_failed'],
  returned_at_store: ['received_by_merchant'],
  delivered: [],
  returned: ['received_by_merchant'],
  received_by_merchant: [],
  return_initiated: ['returned', 'delivery_failed'],
  delivery_failed: [],
  not_received: ['return_initiated', 'delivery_failed'],
  cancelled: [],
  in_branch_transit: ['pending', 'cancelled'],
  // Legacy
  picked_up: ['in_transit', 'returned', 'delivery_failed'],
  in_transit: ['arrived_at_branch', 'delivered', 'returned', 'delivery_failed'],
  arrived_at_branch: ['out_for_delivery', 'returned', 'delivery_failed'],
  out_for_delivery: ['delivered', 'returned', 'delivery_failed'],
};

/** All statuses company staff can pick in admin override / bulk update */
export const ADMIN_STATUS_OPTIONS = [
  'pending', 'assigned', 'accepted', 'picked_up', 'in_transit',
  'on_the_way_to_store', 'arrived_at_store', 'picked_up_from_store',
  'on_the_way_to_customer', 'arrived_at_customer', 'delivered', 'not_delivered',
  'return_initiated', 'returning_to_store', 'returned_at_store', 'returned', 'received_by_merchant',
  'delivery_failed', 'not_received', 'cancelled', 'postponed',
];

export const RIDER_STATUS_LABELS = {
  active: 'نشط',
  busy: 'مشغول',
  offline: 'غير متصل',
};

export const RIDER_STATUS_COLORS = {
  active: '#4caf50',
  busy: '#ff9800',
  offline: '#9e9e9e',
};

/** Inter-branch truck bag (`TRF-…`) — not last-mile order (`SHP-…`). */
export const BRANCH_SHIPMENT_STATUS_LABELS = {
  draft: 'مسودة',
  dispatched: 'في الطريق',
  partially_received: 'استلام جزئي',
  received: 'مستلمة',
  cancelled: 'ملغاة',
};

export const BRANCH_SHIPMENT_STATUS_COLORS = {
  draft: '#78909c',
  dispatched: '#1565c0',
  partially_received: '#ef6c00',
  received: '#2e7d32',
  cancelled: '#c62828',
};

export const BRANCH_SHIPMENT_LINE_STATUS_LABELS = {
  pending: 'بانتظار الاستلام',
  received: 'مستلم',
  missing: 'مفقود',
};

export const BRANCH_SHIPMENT_LINE_STATUS_COLORS = {
  pending: '#ef6c00',
  received: '#2e7d32',
  missing: '#c62828',
};
